import { toState } from '../redux/functions';
/**
 * Rooms that start with the microphone off for everyone in them:
 * - p2p- (direct call) and group- (group call): deaf-to-deaf platform calls
 *   (Robert, 2026-10-05).
 * - vrs- (a VRS call, also an interpreter's call-back vrs-callback-): "in a
 *   VRS call, the mic is muted by default in the room with the deaf person"
 *   (Robert, 2026-10-06).
 *
 * The server mints these names (vrs-server/ws/room-utils.js
 * generateFriendlyRoomName). A vri- room (VRI) is not on the list: there the
 * interpreter, the Deaf person and the hearing person start with the mic on.
 * Jobs (job-) and VideoMail rooms are not on the list either.
 */
const MUTED_AT_START_ROOM = /^(p2p|group|vrs)-/;
/**
 * Whether this person joins the room with the microphone off because of the
 * kind of call the room is for (see MUTED_AT_START_ROOM). Everyone in such a
 * room starts muted, the interpreter and the captioner too, and turns the
 * microphone on with the toolbar button. This rule wins over the "mic on"
 * join options and settings (the portals' forceMicOn, the apps'
 * startWithAudioMuted: false), so the room is the one place that decides.
 *
 * Only the room's microphone. The interpreter's phone call to a hearing
 * party (Twilio, interpreter-phone/services/TwilioVoiceService) has its own
 * audio and its own mute, and stays open.
 *
 * @param {Object|Function} stateful - The redux state object or {@code getState} function.
 * @param {string} [roomName] - The room being joined, when the state does not have it yet (SET_ROOM).
 * @returns {boolean}
 */
export function startsMutedInPlatformCall(stateful, roomName) {
    const room = roomName ?? toState(stateful)['features/base/conference']?.room;
    return typeof room === 'string' && MUTED_AT_START_ROOM.test(room);
}
